import {
    LOGIN,
    SET_USER,
    LOGOUT,
    ADD_ORDER_ITEM,
    MODIFY_ORDER_ITEM,
    REMOVE_ORDER_ITEM,
    CLEAR_ORDER,
    SET_PARAMS
} from './actionTypes'

// Auth
export const login = token => ({
    type: LOGIN,
    token
})

export const setuser = user => ({
    type: SET_USER,
    user
})

export const logout = () => ({
    type: LOGOUT
})

// Organization
export const setparams = params => ({
    type: SET_PARAMS,
    params
})

// Order
export const addOrderItem = (variant, item) => ({
    type: ADD_ORDER_ITEM,
    variant,
    item
})

export const modifyOrderItem = (index, qty, price) => {
    return {
        type: MODIFY_ORDER_ITEM,
        index,
        qty,
        price
    }
}

export const removeOrderItem = index => ({
    type: REMOVE_ORDER_ITEM,
    index
})

export const clearOrder = () => ({
    type: CLEAR_ORDER
})
